// import React from 'react';
// import { Container, Row, Col } from 'react-bootstrap';
// // import hardwareImage from "../../assets/images/operating.avif";
// import anatomy from '../../assets/images/anatomyPic2.jpeg';
// import './immersiveNew.css'
// import { Card } from 'react-bootstrap-v5';

// import sound from '../../assets/icons/immersiveNew/soundSystem.svg'
// import controller from '../../assets/icons/immersiveNew/controller.svg'
// import media from '../../assets/icons/immersiveNew/media.svg'
// import glass from '../../assets/icons/immersiveNew/glassDoor2.svg'
// import versatality from '../../assets/icons/immersiveNew/versatality.svg'
// import display from '../../assets/icons/immersiveNew/display.svg'
// const Anatomy = () => {

//  const features = [
//   { icon: controller, title: "Controls", text: "Intuitive control via a choice of wireless devices, and a customisable interface for simple content access." },
//   { icon: glass, title: "Glass windows, walls and doors", text: "Any existing glass can be covered by a retractable, colour-matched blind." },
//   { icon: sound, title: "Sound system", text: "5.1 immersive sound system, with the option to upgrade to a fully-spatialised system." },
//   { icon:display, title: "The display", text: "Typically, an array of 4-6 ultra-short-throw projectors, retracted into the ceiling." },
//   { icon: versatality, title: "Versatility", text: "Can be retrofitted into most meeting rooms, conference rooms, and workspaces." },
//   { icon: media, title: "Immersive Media Player", text: "Housed in a nearby server room and fits within the envelope of the corporate IT network." },
// ];
//   return (
//     <div className='mxr__section'>
//       <Container>
//         <Row className='align-items-center'>
//           <h2 className='mxr__section-title text-uppercase text-center'>
//             The Anatomy of an immerasive room
//           </h2>
//             {features.map((feature, index) => (
//         <Col key={index} md={6} className="mb-4">
//           <Card className="border-0">
//             <Card.Body>
//               <img src={feature.icon} alt={feature.title} width={'80px'} className='anatomyIcon' />
//               <Card.Title className="fw-bold y-10">{feature.title}</Card.Title>
//               <Card.Text className="text-muted">{feature.text}</Card.Text>
//             </Card.Body>
//           </Card>
//         </Col>
//       ))}

//           <Col md={6}>
//             <div className=''>
//               <img src={anatomy} alt='Hardware Upgrade' className='anatomyImage' />
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default Anatomy;


import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import anatomy from '../../assets/images/anatomyPic2.jpeg';
import './immersiveNew.css';

import sound from '../../assets/icons/immersiveNew/soundSystem2.svg';
import controller from '../../assets/icons/immersiveNew/controller.svg';
import media from '../../assets/icons/immersiveNew/media.svg';
import glass from '../../assets/icons/immersiveNew/glassDoor2.svg';
import versatality from '../../assets/icons/immersiveNew/versatality.svg';
import display from '../../assets/icons/immersiveNew/display.svg';

const Anatomy = () => {
  const features = [
    { icon: controller, title: 'Controls', text: 'Intuitive control via a choice of wireless devices, and a customisable interface for simple content access.' },
    { icon: glass, title: 'Glass windows, walls and doors', text: 'Any existing glass can be covered by a retractable, colour-matched blind.' },
    { icon: sound, title: 'Sound system', text: '5.1 immersive sound system, with the option to upgrade to a fully-spatialised system.' },
    { icon: display, title: 'The display', text: 'Typically, an array of 4-6 ultra-short-throw projectors, retracted into the ceiling.' },
    { icon: versatality, title: 'Versatility', text: 'Can be retrofitted into most meeting rooms, conference rooms, and workspaces.' },
    { icon: media, title: 'Immersive Media Player', text: 'Housed in a nearby server room and fits within the envelope of the corporate IT network.' },
  ];

  return (
    <div className='mxr__section'>
      <Container>
        <h2 className='mxr__section-title text-uppercase text-center mb-4'>
          The Anatomy of an Immersive Room
        </h2>

        <Row className='align-items-center'>
          <Col md={7}>
            <Row>
              {features.map((feature, index) => (
                <Col key={index} sm={6} className='mb-2'> 
                  <Card className='border-0 '>
                    <Card.Body className='d-flex align-items-start'>
                      <img src={feature.icon} alt={feature.title} width='80px' className='me-3 ' /> 
                      <div>
                        <Card.Title className='fw-bold'>{feature.title}</Card.Title>
                        <Card.Text className='text-muted'>{feature.text}</Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>

          <Col md={5} className='text-center'>
            <img src={anatomy} alt='Hardware Upgrade' className='anatomyImage img-fluid' />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Anatomy;
